var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33107 12.8525H1.2833C0.92613 12.8525 0.636719 13.1421 0.636719 13.4991V39.3532C0.636719 39.7103 0.92613 39.9997 1.2833 39.9997H9.33107C9.68825 39.9997 9.97766 39.7103 9.97766 39.3532V13.4991C9.97766 13.1421 9.68825 12.8525 9.33107 12.8525Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31052 0C2.38227 0 0 2.37969 0 5.3047C0 8.23101 2.38227 10.6116 5.31052 10.6116C8.23644 10.6116 10.6168 8.23088 10.6168 5.3047C10.6169 2.37969 8.23644 0 5.31052 0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8017 12.21C26.5694 12.21 24.18 13.5995 22.7308 15.1783V13.4991C22.7308 13.1421 22.4414 12.8525 22.0842 12.8525H14.3771C14.0199 12.8525 13.7305 13.1421 13.7305 13.4991V39.3532C13.7305 39.7103 14.0199 39.9997 14.3771 39.9997H22.4072C22.7644 39.9997 23.0538 39.7103 23.0538 39.3532V26.5614C23.0538 22.2509 24.2247 20.5716 27.2295 20.5716C30.5019 20.5716 30.762 23.2637 30.762 26.7832V39.3533C30.762 39.7105 31.0514 39.9999 31.4086 39.9999H39.4417C39.7989 39.9999 40.0883 39.7105 40.0883 39.3533V25.1719C40.0883 18.7623 38.8662 12.21 29.8017 12.21Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSvg);
export default __webpack_public_path__ + "static/media/linkedinSVG.23d0612a86c6ea9e5324a9629506b277.svg";
export { ForwardRef as ReactComponent };